// Contenuti pagina pubblica "Lavora con noi" - Metal Covering S.r.l.
// Testi forniti dall'azienda. Descrizioni ruoli + sezione "Chi siamo".

export const COMPANY = {
  chiSiamo: {
    title: 'Chi siamo',
    paragraphs: [
      'Metal Covering S.r.l. è un\u2019azienda italiana specializzata nella preparazione delle superfici, nei trattamenti anticorrosivi e nella manutenzione di serbatoi, tubazioni, carpenterie e infrastrutture industriali.',
      'Operiamo principalmente nei settori petrolifero, petrolchimico, energetico e dell\u2019industria pesante, intervenendo all\u2019interno di raffinerie, depositi carburanti, tank farm, stabilimenti produttivi e impianti industriali complessi. Nel corso degli anni abbiamo sviluppato competenze specifiche anche per le industrie chimiche, farmaceutiche, alimentari e tessili.',
      'La nostra attività non si limita all\u2019esecuzione della sabbiatura e della verniciatura: affianchiamo il cliente in tutte le fasi del lavoro, dall\u2019analisi preliminare delle superfici fino alla manutenzione programmata nel tempo.',
      'L\u2019obiettivo è garantire lavorazioni sicure, controllate e capaci di prolungare la vita utile degli impianti e delle strutture trattate. Metal Covering opera in Italia e può organizzare attività e commesse anche in ambito europeo.',
    ],
  },

  cosaFacciamo: [
    {
      title: 'Preparazione delle superfici',
      items: [
        'Sabbiatura abrasiva a secco e con abrasivo garnet',
        'Sabbiatura abrasiva a vapore e vapor blasting (tecnologia GRACO EcoQuip)',
        'Pallinatura, hydroblasting, water-jetting e lavaggio ad alta/altissima pressione',
        'Rimozione di ruggine, calamina e vecchi rivestimenti; decontaminazione',
        'Controllo del grado di preparazione, rugosità, polverosità e contaminazione salina',
      ],
    },
    {
      title: 'Verniciatura e rivestimenti protettivi',
      items: [
        'Cicli protettivi e anticorrosivi per atmosfere aggressive, agenti chimici, umidità e immersione',
        'Primer, zincanti, epossidici, poliuretanici, intermedi ad alto spessore e finiture',
        'Applicazione airless, a pennello e rullo, stripe coat',
        'Ripristino e riparazione localizzata dei cicli protettivi',
        'Controllo spessori umidi/secchi e delle condizioni ambientali',
      ],
    },
    {
      title: 'Manutenzione di serbatoi industriali',
      items: [
        'Fondi, mantelli interni ed esterni, virolature, tetti fissi e galleggianti',
        'Strutture interne, accessori, tubazioni, passerelle e carpenterie metalliche',
        'Allestimento area, lavaggio, preparazione, sabbiatura e verniciatura',
        'Attività in ambienti confinati con documentazione finale',
      ],
    },
    {
      title: 'Impermeabilizzazione e poliurea',
      items: [
        'Sistemi impermeabilizzanti in poliurea pura bicomponente',
        'Vasche, bacini di contenimento, coperture e superfici industriali',
        'Membrana continua priva di giunti con rapidi tempi di reazione',
      ],
    },
    {
      title: 'Protezione passiva dal fuoco (tramite partner qualificati)',
      items: [
        'Coordinamento di sistemi di protezione passiva dal fuoco (PFP) con ditte terze specializzate',
        'Preparazione delle superfici a supporto dei cicli antincendio',
        'Metal Covering non esegue direttamente l\u2019applicazione di intumescenti/cementizi antincendio: ci appoggiamo a partner qualificati',
      ],
    },
    {
      title: 'Metallizzazione TSA e lavorazioni complementari',
      items: [
        'Metallizzazione TSA (Thermally Sprayed Aluminium) per ambienti fortemente corrosivi',
        'Segnaletica orizzontale e rivestimenti per pavimentazioni',
        'Trattamenti localizzati, ripristini manutentivi e noleggio attrezzature',
      ],
    },
  ],

  controlloQualita: {
    intro: 'La qualità non viene verificata soltanto al termine della lavorazione: i controlli vengono programmati prima, durante e dopo ogni fase operativa. In azienda è presente un ispettore NACE interno.',
    items: [
      'Temperatura aria/supporto, umidità relativa, punto di rugiada',
      'Controllo contaminazione salina e polverosità',
      'Verifica del grado di preparazione e del profilo di rugosità',
      'Spessore film umido (WFT) e film secco (DFT)',
      'Controlli di adesione e Holiday test, quando previsto',
      'Verifica visiva del rivestimento, difetti, porosità e discontinuità',
      'Registrazione lotti, rapporti di miscelazione, pot life e intervalli di ricopertura',
    ],
  },

  sicurezza: {
    intro: 'La sicurezza è parte integrante dell\u2019organizzazione del lavoro, dalla pianificazione preliminare fino alla chiusura della commessa. Le attività sono organizzate nel rispetto del D.Lgs. 81/08.',
    durante: [
      'Meeting pre-ingresso e Toolbox Meeting',
      'JLA/JSA e controllo dei permessi di lavoro',
      'Sopralluoghi HSE e verifiche sull\u2019uso corretto dei DPI',
      'LPO, segnalazione dei Near Miss e monitoraggio delle azioni correttive',
      'Riunioni periodiche di sicurezza',
    ],
    documenti: [
      'POS, PSC, DUVRI e permessi di lavoro',
      'Piani di emergenza e procedure per ambienti confinati (Allegato 8)',
      'Documentazione interferenze, nomina addetti emergenze, consultazione RLS',
      'Controllo di formazione, attestati e idoneità',
    ],
  },

  ambientiConfinati: {
    intro: 'Metal Covering possiede esperienza specifica nelle attività svolte in ambienti confinati. Ogni intervento viene pianificato con particolare attenzione a isolamento, bonifica, ventilazione, comunicazione ed emergenza.',
    items: [
      'Ventilazione forzata e illuminazione ATEX',
      'Sistemi di abbattimento polveri e aria respirabile filtrata',
      'Rilevatori BiGas e multigas, autorespiratori',
      'Imbracature, treppiedi, verricelli, recuperatori, barelle e maschere di fuga',
      'Verifica personale autorizzato, permessi, monitoraggio atmosfera e piano di recupero',
    ],
  },

  ambiente: {
    intro: 'Metal Covering integra la tutela ambientale nell\u2019organizzazione delle proprie attività, con particolare attenzione al contenimento delle polveri e alla gestione dei rifiuti.',
    items: [
      'Tecnologie che riducono la dispersione delle polveri (es. sabbiatura a vapore)',
      'Contenimento delle aree operative e gestione controllata degli abrasivi',
      'Raccolta e separazione dei rifiuti; prevenzione della contaminazione del suolo',
      'Gestione corretta di pitture e solventi, riduzione degli sprechi',
      'Ricerca di tecnologie più efficienti e sostenibili',
    ],
  },

  // Badge testuali originali (NON loghi ufficiali ISO/IQNet).
  certificazioni: [
    { code: 'ISO 9001:2015', name: 'Sistema di gestione per la qualità' },
    { code: 'ISO 14001:2015', name: 'Sistema di gestione ambientale' },
    { code: 'ISO 45001:2018', name: 'Salute e sicurezza sul lavoro' },
  ],
  certificazioniNota: 'Le certificazioni rappresentano l\u2019impegno aziendale verso la qualità delle lavorazioni, la prevenzione degli infortuni, la tutela dell\u2019ambiente e il miglioramento continuo.',

  clienti: {
    formula: 'Metal Covering opera per primarie realtà nazionali e internazionali nei settori Oil & Gas, petrolchimico, energetico e dell\u2019industria pesante, direttamente o nell\u2019ambito di commesse affidate da general contractor specializzati.',
    names: ['ENI', 'SARPOM', 'Gruppo API', 'SERAM', 'PARESA', 'Walter Tosto', 'CO.M.CE.', 'Ecosistem', 'Ecofox', 'Aversana Petroli', 'Fiamma 2000', 'Econet', 'Carboil'],
    esperienze: [
      'Sabbiatura e verniciatura di serbatoi',
      'Manutenzione di fondi, mantelli e tetti',
      'Trattamenti anticorrosivi e lavorazioni interne/esterne',
      'Attività in ambienti confinati',
      'Controlli di qualità e gestione di cantieri industriali',
    ],
  },

  perche: [
    'Esperienza negli impianti industriali complessi e specializzazione nei serbatoi',
    'Esperienza consolidata negli ambienti confinati',
    'Preparazione tecnica del personale e attenzione alla sicurezza',
    'Tecnologie moderne per la preparazione delle superfici',
    'Controlli di qualità durante tutte le fasi',
    'Integrazione tra sabbiatura, verniciatura, impermeabilizzazione e protezione passiva',
    'Tracciabilità delle lavorazioni e capacità di intervenire in Italia e in Europa',
  ],

  metodo: [
    'Analisi della richiesta e delle specifiche',
    'Sopralluogo e valutazione preliminare',
    'Individuazione delle tecnologie e del ciclo',
    'Pianificazione di sicurezza, qualità e ambiente',
    'Organizzazione di personale e attrezzature',
    'Preparazione dell\u2019area ed esecuzione della preparazione superficiale',
    'Controllo del grado di preparazione',
    'Applicazione del ciclo protettivo con controlli in corso d\u2019opera',
    'Verifiche finali e gestione delle eventuali riprese',
    'Pulizia, ripristino dell\u2019area e consegna della documentazione',
  ],
};

export const COMMON_NOTE = 'L\u2019inquadramento, il livello e le condizioni economiche saranno definiti durante il colloquio in base all\u2019esperienza, alle competenze e al livello di autonomia. Per l\u2019attività ordinaria presso Trecate o Lainate non è previsto l\u2019alloggio aziendale: è necessario poter raggiungere autonomamente la sede di lavoro. In caso di eventuali trasferte autorizzate fuori sede, si applicheranno le condizioni previste dall\u2019azienda.';

export const ROLES = {
  'aspp-operations': {
    salary: '\u20ac 1.400 \u2013 \u20ac 2.200 netti/mese (indicativo)',
    intro: [
      'L\u2019ASPP & Operations Coordinator è una figura operativa e organizzativa che supporta Metal Covering nella gestione della sicurezza, del personale, del magazzino e delle scadenze aziendali.',
      'La sede principale sarà collegata alle attività Metal Covering presso lo stabilimento SARPOM di Trecate, con rapporti anche con l\u2019ufficio di Lainate e con eventuali altri cantieri.',
      'Non è un ruolo esclusivamente amministrativo: la persona dovrà essere presente sul campo, effettuare sopralluoghi, controllare le lavorazioni e confrontarsi quotidianamente con operai, preposti, responsabili di cantiere, RSPP e referenti del cliente.',
    ],
    sections: [
      { title: 'Attività come ASPP', items: [
        'Svolgere formalmente il ruolo di Addetto al Servizio di Prevenzione e Protezione',
        'Collaborare con datore di lavoro, RSPP, dirigenti, preposti e responsabili di cantiere',
        'Supportare individuazione e valutazione dei rischi',
        'Verificare l\u2019applicazione delle procedure di sicurezza',
        'Contribuire alla documentazione HSE e partecipare alle riunioni di sicurezza',
        'Monitorare azioni preventive e correttive; segnalare anomalie e condizioni pericolose',
        'Mantenere aggiornati registri, checklist e scadenziari HSE',
        'Supportare l\u2019azienda durante audit, ispezioni e controlli del cliente',
      ] },
      { title: 'Controlli sul campo', items: [
        'Sopralluoghi regolari nelle aree di lavoro',
        'Verifica del rispetto delle procedure aziendali e delle disposizioni del cliente/stabilimento',
        'Controllo dell\u2019uso corretto, dell\u2019adeguatezza e dello stato dei DPI',
        'Ordine, pulizia, delimitazione aree, cartellonistica, accessi e vie di fuga',
        'Stato delle attrezzature, tubazioni, raccordi, collegamenti e messa a terra',
        'Validità dei permessi di lavoro e corrispondenza con l\u2019attività autorizzata',
        'Verifica di attestati, formazione e idoneità adeguati alla mansione',
        'Registrazione comportamenti e condizioni non sicure; documentazione fotografica',
        'Richiesta di messa in sicurezza e monitoraggio della chiusura delle azioni correttive',
        'Richiesta di sospensione delle attività con pericolo grave o non controllato (se previsto dai poteri attribuiti)',
      ] },
      { title: 'Meeting pre-ingresso', items: [
        'Organizzare il meeting e verificare identità, documentazione, formazione e idoneità',
        'Illustrare regole generali dello stabilimento e regole specifiche Metal Covering',
        'Informare su rischi, comportamenti vietati, percorsi e aree vietate',
        'Illustrare punti di raccolta e procedure di emergenza',
        'Verificare la comprensione, rispondere alle domande e registrare data/orario/argomenti',
        'Raccogliere le firme e conservare il verbale nel fascicolo digitale del cantiere',
        'Impedire l\u2019ingresso al personale privo dei requisiti, informando i responsabili',
      ] },
      { title: 'Toolbox Meeting', items: [
        'Analizzare preventivamente la lavorazione e individuare i rischi e le interferenze',
        'Illustrare sequenza attività, JLA/JSA, misure di prevenzione e DPI obbligatori',
        'Verificare disponibilità DPI e procedure di emergenza',
        'Coinvolgere la squadra e verificare la comprensione delle istruzioni',
        'Registrare i partecipanti, raccogliere firme e conservare il verbale',
        'Ripetere il Toolbox quando cambiano lavorazione, area, squadra, attrezzature, rischi, permessi o interferenze',
      ] },
      { title: 'JLA/JSA e documentazione operativa', items: [
        'Preparare Job Loss Analysis e Job Safety Analysis',
        'Suddividere la lavorazione in fasi e individuare pericoli e rischi',
        'Identificare misure preventive, DPI, ruoli e responsabilità',
        'Aggiornare la JLA/JSA al variare delle condizioni operative',
        'Presentare il documento alla squadra e raccogliere le prese visione',
      ] },
      { title: 'Gestione degli ambienti confinati', items: [
        'Preparare e controllare l\u2019Allegato 8 e il permesso di ingresso',
        'Verificare personale autorizzato, formazione, esperienza triennale e idoneità',
        'Controllare isolamento, bonifica, ventilazione e monitoraggio dell\u2019atmosfera',
        'Verificare rilevatori BiGas/multigas (carica, taratura, bump test)',
        'Controllare sistemi di comunicazione e presenza dell\u2019addetto esterno',
        'Verificare autorespiratori, treppiede, verricello, imbracature, barella e piano di recupero',
        'Richiedere la sospensione dell\u2019ingresso in presenza di condizioni non sicure',
      ] },
      { title: 'Programma LPS presso SARPOM', items: [
        'Referente operativo Metal Covering per il programma LPS',
        'Partecipare alle riunioni LPS del cliente e organizzare allineamenti interni',
        'Effettuare LPO sul campo; registrare comportamenti sicuri e da correggere',
        'Aprire Near Miss e segnalazioni HSE; individuare e assegnare azioni correttive',
        'Monitorare avanzamento e chiusura; preparare report periodici e indicatori',
        'Promuovere la partecipazione del personale alla sicurezza',
      ] },
      { title: 'Gestione del magazzino', items: [
        'Registrare materiali in entrata/uscita e tenere aggiornate le giacenze',
        'Organizzare posizionamento prodotti e assegnazione attrezzature',
        'Controllare restituzioni ed eventuali danni',
        'Segnalare materiali esauriti e predisporre richieste di reintegro',
        'Preparare richieste di offerta e preventivi, con confronto preliminare',
        'Trasmettere le richieste all\u2019ufficio acquisti e verificare le consegne',
      ] },
      { title: 'Gestione delle scadenze', items: [
        'DPI, imbracature, maschere, filtri, autorespiratori',
        'Rilevatori BiGas/multigas, bump test, tarature, spessimetri, termoigrometri',
        'Estintori, cassette primo soccorso, attrezzature e manutenzioni',
        'Mezzi aziendali, revisioni e assicurazioni',
        'Attestati dei lavoratori, visite mediche, documenti aziendali e di cantiere',
        'Per ogni scadenza: data, documento allegato, responsabile, notifiche e rinnovo',
      ] },
      { title: 'Gestione operativa delle risorse umane', items: [
        'Controllo timbrature, entrate/uscite e mancate timbrature',
        'Verifica rapportini giornalieri e confronto con presenze e ore lavorate',
        'Report presenze; registrazione ferie, permessi e assenze',
        'Monitoraggio attestati, corsi, visite mediche e idoneità',
        'Supporto all\u2019ingresso di nuovi dipendenti e alla documentazione di accesso ai cantieri',
      ] },
    ],
  },

  'sabbiatore': {
    salary: '\u20ac 1.400 \u2013 \u20ac 2.200 netti/mese (indicativo)',
    intro: [
      'Il sabbiatore industriale è responsabile della preparazione delle superfici metalliche prima dell\u2019applicazione dei cicli protettivi e anticorrosivi.',
      'Lavora su serbatoi industriali, fondi e tetti, mantelli, tubazioni, carpenterie, strutture metalliche, lamiere e componenti industriali.',
      'Deve conoscere le attrezzature, i diversi abrasivi, i gradi di preparazione e i principali controlli della superficie.',
    ],
    sections: [
      { title: 'Preparazione dell\u2019attività', items: [
        'Leggere le istruzioni di lavoro e comprendere il grado di preparazione richiesto',
        'Verificare la superficie ed eventuale presenza di olio, grasso o contaminanti',
        'Controllare condizioni ambientali: temperatura aria/supporto, umidità, punto di rugiada',
        'Verificare disponibilità e granulometria dell\u2019abrasivo',
        'Controllare compressore, sabbiatrice, tubazioni, raccordi, ugelli e dispositivi di sicurezza',
        'Indossare i DPI previsti e partecipare al Toolbox Meeting',
      ] },
      { title: 'Preparazione della sabbiatrice', items: [
        'Controllare serbatoio macchina, valvole e dispositivi di comando',
        'Verificare tubazioni aria, raccordi di sicurezza, frusta antisbandamento e comando uomo morto',
        'Controllare ugello e usura; selezionare la misura corretta',
        'Controllare pressione, portata e assenza di acqua/olio nell\u2019aria',
        'Gestire correttamente il caricamento dell\u2019abrasivo e segnalare anomalie',
      ] },
      { title: 'Esecuzione della sabbiatura', items: [
        'Mantenere corretta distanza e inclinazione dell\u2019ugello, procedendo in modo uniforme',
        'Evitare zone non trattate ed eccessiva incisione della superficie',
        'Raggiungere il grado di preparazione richiesto controllando progressivamente il risultato',
        'Rimuovere ruggine, calamina, vecchie pitture e contaminanti',
        'Segnalare difetti del metallo emersi ed evitare la ricontaminazione',
        'Coordinarsi con gli altri operatori e rispettare delimitazioni e procedure',
      ] },
      { title: 'Gradi di preparazione e controllo', items: [
        'Conoscere Sa 1, Sa 2, Sa 2½ e Sa 3',
        'Riconoscere ruggine residua, calamina, vecchia pittura, ombreggiature, macchie e contaminazioni',
        'Controllo visivo, grado di preparazione e rugosità',
        'Rimuovere polvere e abrasivo; verificare contaminazioni saline quando previsto',
        'Proteggere la superficie preparata e rispettare il tempo massimo prima della verniciatura',
        'Segnalare eventuale formazione di flash rust',
      ] },
      { title: 'Pulizia, fine attività e competenze', items: [
        'Raccogliere abrasivo esausto, pulire l\u2019area e separare i rifiuti',
        'Scaricare la pressione in sicurezza e pulire ugelli e tubazioni',
        'Segnalare usura o guasti e compilare i rapportini',
        'Conoscere sabbiatrici, compressori, essiccatori, ugelli, abrasivi e granulometrie',
        'Conoscere pressioni, portate, rugosità, punto di rugiada e contaminazione da polvere/sali',
        'Conoscere autorespiratori, DPI e procedure per spazi confinati e lavori in quota',
      ] },
    ],
  },

  'verniciatore': {
    salary: '\u20ac 1.400 \u2013 \u20ac 2.200 netti/mese (indicativo)',
    intro: [
      'Il verniciatore industriale è responsabile della preparazione e applicazione dei prodotti vernicianti destinati alla protezione anticorrosiva delle superfici metalliche.',
      'Lavora su serbatoi, tubazioni, carpenterie, strutture metalliche, lamiere, componenti industriali e superfici interne ed esterne.',
    ],
    sections: [
      { title: 'Controlli prima della verniciatura', items: [
        'Leggere ciclo di verniciatura, scheda tecnica e scheda di sicurezza',
        'Controllare grado di preparazione, pulizia, polvere, contaminazioni e rugosità',
        'Controllare temperatura aria/supporto, umidità relativa e punto di rugiada',
        'Verificare conformità delle condizioni e gli intervalli di ricopertura',
        'Preparare l\u2019attrezzatura, indossare i DPI e partecipare al Toolbox Meeting',
      ] },
      { title: 'Preparazione e catalisi del prodotto', items: [
        'Identificare componente A e B e verificare il rapporto di miscelazione',
        'Calcolare le quantità e miscelare con strumenti puliti nelle proporzioni corrette',
        'Rispettare tempo di induzione e diluizione consentita',
        'Conoscere il pot life e non utilizzare il prodotto oltre il limite',
        'Registrare lotto e quantità ed evitare contaminazioni',
      ] },
      { title: 'Applicazione a pennello e rullo', items: [
        'Selezionare pennello/rullo adeguato e applicare uniformemente',
        'Evitare accumuli e colature; raggiungere lo spessore richiesto',
        'Trattare correttamente angoli, bordi e saldature ed eseguire lo stripe coat',
        'Verificare continuamente la copertura ed evitare contaminazioni tra le mani',
      ] },
      { title: 'Applicazione airless', items: [
        'Preparare la pompa airless; verificare pescante, filtri, tubazioni e pistola',
        'Selezionare ugello corretto, regolare la pressione ed effettuare prova del ventaglio',
        'Mantenere distanza corretta, pistola perpendicolare e velocità uniforme',
        'Sovrapporre correttamente le passate; evitare code, overspray, colature e accumuli',
        'Controllare progressivamente lo spessore e gestire in sicurezza l\u2019alta pressione',
        'Non avvicinare le mani all\u2019ugello e scaricare la pressione prima della manutenzione',
      ] },
      { title: 'Applicazione del ciclo', items: [
        'Applicare primer, zincanti, epossidici, intermedi ad alto spessore, poliuretanici e finiture',
        'Eseguire prodotti bicomponenti, stripe coat e riparazioni localizzate',
        'Rispettare spessore previsto e tempi minimo/massimo di ricopertura',
        'Verificare la compatibilità tra i prodotti e registrare lotto e prodotto utilizzato',
      ] },
      { title: 'Controllo spessori e difetti', items: [
        'Utilizzare pettine per il film umido (WFT) e comprendere rapporto WFT/DFT/solidi in volume',
        'Utilizzare lo spessimetro (DFT) quando autorizzato ed effettuare più misurazioni',
        'Riconoscere spessori insufficienti/eccessivi ed eseguire riprese',
        'Riconoscere colature, overspray, buccia d\u2019arancia, porosità, crateri, bolle e delaminazioni',
        'Individuare la causa dei difetti e proporre la corretta riparazione',
      ] },
      { title: 'Pulizia dell\u2019attrezzatura', items: [
        'Scaricare la pressione e recuperare il prodotto utilizzabile',
        'Pulire pompa, filtri, tubazioni e pistola con il solvente appropriato',
        'Gestire correttamente solventi e rifiuti; controllare l\u2019usura dell\u2019ugello',
        'Segnalare guasti e lasciare l\u2019area in ordine e sicurezza',
      ] },
    ],
  },

  'contabile-cantiere': {
    salary: '\u20ac 1.400 \u2013 \u20ac 2.200 netti/mese (indicativo)',
    intro: [
      'Il contabile di cantiere controlla l\u2019andamento economico delle commesse Metal Covering, mettendo in relazione lavorazioni eseguite, quantità contrattuali e riconosciute, ore, materiali, noleggi, ordini, SAL, SES, fatturazione e costi effettivi.',
      'La sede principale sarà l\u2019ufficio Metal Covering di Lainate, con presenza periodica nei cantieri.',
    ],
    sections: [
      { title: 'Apertura della commessa', items: [
        'Leggere contratto e ordine del cliente; identificare PO e riferimenti contrattuali',
        'Registrare il valore della commessa, prezzi unitari e quantità previste',
        'Creare il budget iniziale e suddividere i costi previsti',
        'Identificare materiali, attrezzature e noleggi; registrare le scadenze contrattuali',
        'Verificare le condizioni di fatturazione e predisporre la struttura di controllo economico',
      ] },
      { title: 'Controllo presenze, ore e materiali', items: [
        'Acquisire rapportini e presenze; controllare ore ordinarie, straordinari, notturne e festive',
        'Confrontare rapportini e timbrature; associare le ore alla commessa corretta',
        'Calcolare il costo della manodopera e preparare report periodici',
        'Registrare i materiali della commessa; controllare quantità ordinate/consegnate e DDT',
        'Confrontare DDT e ordini; gestire resi e segnalare consumi anomali',
      ] },
      { title: 'Ordini di acquisto', items: [
        'A differenza dell\u2019ASPP, il contabile può predisporre ed emettere gli ordini secondo i livelli autorizzativi',
        'Ricevere richieste di acquisto e confrontare preventivi e condizioni',
        'Selezionare il fornitore approvato e preparare l\u2019ordine (commessa, centro di costo, quantità, prezzo, consegna)',
        'Inviare per approvazione e trasmettere al fornitore; monitorare la consegna',
        'Verificare ordine, DDT e fattura; gestire differenze e archiviare i documenti',
      ] },
      { title: 'Noleggi e fornitori', items: [
        'Registrare noleggi, date inizio/fine, canoni, costi accessori e proroghe',
        'Segnalare noleggi da chiudere e verificare trasporti e consegne',
        'Controllare prestazioni dei fornitori e registrare subappalti e servizi',
        'Associare ogni costo alla commessa',
      ] },
      { title: 'Misurazione e SAL', items: [
        'Acquisire misure dai responsabili; controllare disegni e specifiche (AutoCAD quando necessario)',
        'Calcolare superfici, lunghezze e quantità; confrontare previste ed effettive',
        'Preparare libretti delle misure con fotografie e documenti di supporto',
        'Raccogliere lavorazioni eseguite, applicare i prezzi unitari e preparare il SAL',
        'Separare attività contrattuali ed extra; registrare quantità presentate e riconosciute',
        'Aggiornare il residuo della commessa e archiviare il SAL approvato',
      ] },
      { title: 'Extra, PO, SES e fatturazione', items: [
        'Registrare subito le richieste extra con descrizione, autorizzazioni, ore, materiali e mezzi',
        'Preparare il preventivo ed evitare che un extra venga perso o non contabilizzato',
        'Controllare il PO, verificare importi/voci e monitorare il valore residuo',
        'Richiedere/controllare il SES e verificarne la corrispondenza con il SAL',
        'Preparare i documenti per la fatturazione e monitorare lo stato delle fatture',
      ] },
      { title: 'Cost control, reportistica e competenze', items: [
        'Confrontare budget, costi sostenuti/impegnati/previsti, valore prodotto, fatturato, incassato e margini',
        'Preparare report settimanali/mensili, analisi scostamenti e previsioni a finire',
        'Elenchi di extra, ordini aperti, costi non fatturati, SAL da approvare e SES mancanti',
        'Conoscere contabilità di cantiere, SAL, libretti misure, prezzi unitari, budget e cost control',
        'Conoscere DDT, fatture, PO, SES, Excel avanzato (pivot), AutoCAD e preferibilmente SAP',
        'Precisione, autonomia, capacità analitica, organizzazione e comunicazione',
      ] },
    ],
  },

  'autista-patente-c-cqc': {
    note: COMMON_NOTE,
    intro: [
      'Metal Covering cerca una figura flessibile e affidabile che si occupi dei trasporti aziendali e che, quando non sono programmati viaggi, supporti concretamente il magazzino, la manutenzione ordinaria e le squadre operative.',
      'Non è una posizione dedicata esclusivamente alla guida. Il camion e i mezzi necessari ai trasporti sono forniti da Metal Covering. Sede ordinaria: Trecate; è necessario poter raggiungere autonomamente la sede.',
    ],
    sections: [
      { title: 'Attività di trasporto', items: [
        'Guida dei mezzi pesanti aziendali; trasporto materiali e attrezzature',
        'Consegne presso i cantieri e ritiri presso i fornitori',
        'Verifica percorso e limitazioni, rispetto orari e tempi di guida/riposo',
        'Uso corretto del tachigrafo, rapportini di viaggio, km e rifornimenti',
        'Custodia di mezzo, chiavi e documenti; segnalazione guasti e anomalie',
      ] },
      { title: 'Controlli e gestione del carico', items: [
        'Controllo pre-partenza: pneumatici, luci, specchi, perdite, livelli, dotazioni',
        'Sistemazione e ancoraggio del carico (cinghie, catene), rispetto della portata',
        'Verifica DDT e documenti di trasporto; firma consegna e registrazione riserve',
      ] },
      { title: 'Supporto magazzino e manutenzione', items: [
        'Ricezione merce, controllo DDT, picking, preparazione carichi e consegne',
        'Registrazione entrate/uscite, inventari, giacenze, ordine e pulizia',
        'Pulizia attrezzature, controlli visivi, supporto al manutentore e segnalazione guasti',
      ] },
      { title: 'Requisiti e preferenziali', items: [
        'Obbligatori: patente C e CQC merci valide, esperienza di guida mezzi pesanti',
        'Disponibilità a mansioni operative (magazzino, manutenzione, operaio generico)',
        'Preferenziali: patente CE, carta tachigrafica, patentino muletto, PLE, formazione HSE',
        'ADR solo se posseduta (non obbligatoria)',
      ] },
    ],
  },

  'geometra-ingegnere': {
    note: COMMON_NOTE,
    intro: [
      'Metal Covering cerca un geometra, un ingegnere o un tecnico con formazione equivalente a supporto dell\u2019ufficio tecnico e delle commesse industriali.',
      'Non è una posizione esclusivamente d\u2019ufficio: sono previsti sopralluoghi, rilievi e controlli in cantiere. Il sistema non penalizza il geometra rispetto all\u2019ingegnere o viceversa.',
    ],
    sections: [
      { title: 'Analisi tecnica e rilievi', items: [
        'Lettura di capitolati, specifiche, disegni e individuazione lavorazioni/quantità',
        'Sopralluoghi e rilievi dimensionali, fotografie tecniche, schizzi e verbali',
        'Gestione revisioni dei documenti e organizzazione file per commessa',
      ] },
      { title: 'Computi, AutoCAD e preventivi', items: [
        'Calcolo superfici di serbatoi, fondi, tetti, mantelli, tubazioni e carpenterie',
        'Computi metrici, confronto quantità contrattuali/rilevate, segnalazione differenze',
        'AutoCAD/DWG: misure, planimetrie, tavole per offerte/procedure/SAL, export PDF',
        'Supporto ai preventivi tecnici (quantità, materiali, manodopera, tempi, extra)',
      ] },
      { title: 'Pianificazione e supporto cantieri/SAL', items: [
        'Cronoprogrammi, sequenze operative, stato attività e report di avanzamento',
        'Supporto al capo cantiere, registrazione avanzamento, varianti ed extra',
        'Collaborazione ai SAL con libretti delle misure e allegati grafici',
      ] },
      { title: 'Titoli accettati e requisiti', items: [
        'Diploma geometra/CAT o laurea in ingegneria (civile, edile, meccanica, industriale) o titolo equivalente',
        'AutoCAD, Excel, capacità di rilievo e computo, precisione e organizzazione',
        'Patente B, disponibilità a sopralluoghi e trasferte occasionali',
        'Preferenziali: esperienza industriale/Oil&Gas/serbatoi, SAP, BIM, inglese, ISO',
      ] },
    ],
  },

  'operaio-generico': {
    note: COMMON_NOTE,
    intro: [
      'Metal Covering cerca un operaio generico da inserire nelle squadre per supportare le attività industriali e di cantiere, sotto la direzione del preposto.',
      'La posizione è aperta anche a candidati seri e motivati da formare, interessati a crescere come sabbiatori o verniciatori. Le attività specialistiche richiedono formazione, affiancamento e autorizzazione.',
    ],
    sections: [
      { title: 'Preparazione aree e movimentazione', items: [
        'Allestimento cantiere, delimitazioni, cartellonistica e protezioni',
        'Preparazione e trasporto materiali, utensili e attrezzature; ordine e pulizia',
        'Movimentazione materiali e carico/scarico secondo la formazione ricevuta',
      ] },
      { title: 'Supporto a sabbiatura e verniciatura', items: [
        'Supporto al sabbiatore: preparazione aree, movimentazione abrasivi, caricamento, pulizia',
        'Supporto al verniciatore: preparazione area, protezioni, tubazioni airless, materiali di consumo',
        'Attività specialistiche solo con formazione e autorizzazione (no uso autonomo sabbiatrice/airless/catalisi)',
      ] },
      { title: 'Pulizia industriale e sicurezza', items: [
        'Pulizia aree e attrezzature, raccolta abrasivo, separazione rifiuti, ripristino aree',
        'Partecipazione a meeting pre-ingresso e Toolbox, uso DPI, rispetto permessi e JLA/JSA',
        'Ambienti confinati solo se formato, idoneo e autorizzato',
      ] },
      { title: 'Profilo junior da formare', items: [
        'Aperto anche a chi non ha esperienza ma dimostra motivazione, affidabilità e disponibilità',
        'Percorso possibile: crescita come sabbiatore, verniciatore o entrambi',
        'Requisiti: serietà, puntualità, lavoro in squadra, attenzione alla sicurezza, raggiungere Trecate',
      ] },
    ],
  },
};
